import { request } from "./request.js";

async function get(key) {
    return await request("/receptionist", { key: key }, "POST");
}

async function save(data) {
    return await request("/receptionist/save", data, "POST");
}

export { get, save };
